import { CARRIER_LOGOS } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const items = [...CARRIER_LOGOS, ...CARRIER_LOGOS];
  return (
    <div
      className="overflow-hidden border-y border-[#0F4C5C]/10 bg-white py-5"
      aria-label={t("home.marqueeAria")}
      data-testid="carrier-marquee"
    >
      <div className="af-marquee-track" style={{ animationDuration: "90s" }}>
        {items.map((carrier, i) => (
          <span
            key={`${carrier.file}-${i}`}
            className="mx-5 inline-flex h-9 w-28 shrink-0 items-center justify-center"
            aria-hidden={i >= CARRIER_LOGOS.length}
          >
            <img
              src={`/assets/carriers/${carrier.file}`}
              alt={i < CARRIER_LOGOS.length ? `${carrier.name} logo` : ""}
              className="max-h-9 w-auto max-w-full object-contain opacity-75 transition-opacity duration-300 hover:opacity-100"
              loading="lazy"
            />
          </span>
        ))}
      </div>
    </div>
  );
}
